<div class="validate-container"
     [class.container]="!expressMode"
     [class.validate-express-container-adp]="expressMode">
    <div class="validate-header">
        <div class="d-flex flex-row align-items-center w-100">
            <div class="d-flex flex-row align-items-center justify-content-between py-3 w-100" *ngIf="expressMode">
                <div>
                    <p class="x-small-text spaced-label text-uppercase m-0">{{ customTitle }}</p>
                    <p class="small-label">Verificación de datos rapida</p>
                </div>
<!--                <button mat-fab-->
<!--                        *ngIf="expressMode"-->
<!--                        class="glance-card-theme-color">-->
<!--                    <span class="material-symbols-rounded">question_mark</span>-->
<!--                </button>-->
            </div>
            <div class="ms-3" [hidden]="expressMode">
                <h5 class="app-module-title m-0">{{ customTitle }}</h5>
                <p class="small-label">Verificación de datos rapida</p>
            </div>
        </div>
    </div>
    <div class="validate-content">
        <div [hidden]="userSelectedAccount">
            <div class="email-list" *ngIf="emailValidation && !phoneValidation">
                <div mat-ripple matRippleColor="#CCCCCC25"
                     class="email-item"
                     [class.card-theme-color]="email === selectedEmail && !expressMode"
                     [class.card-theme-border-color]="email === selectedEmail && !expressMode"
                     [class.glance-card-theme-color]="email === selectedEmail && expressMode"
                     (click)="setSelectedEmail(email)"
                     *ngFor="let email of emails">
                    <div class="d-flex flex-row align-items-center">
                        <span class="material-symbols-rounded primary-icon me-3">
                            {{ email === selectedEmail ? 'radio_button_checked' : 'radio_button_unchecked' }}
                        </span>
                        <div class="lateral-data-img me-3">
                            <span class="material-symbols-rounded square-icon">email</span>
                        </div>
                        <div class="lateral-data-textarea">
                            <p class="medium-text spaced-label text-uppercase m-0"
                               [style.word-break]="'break-all'">
                                {{ email.email }}
                            </p>
<!--                            <p class="small-label" *ngIf="email === selectedEmail">-->
<!--                                Enviaremos un código de verificación-->
<!--                            </p>-->
                        </div>
                    </div>
                    <div class="lateral-data-options">
                        <!--                        <span class="material-symbols-rounded primary-icon">-->
                        <!--                            {{-->
                        <!--                                email === selectedEmail-->
                        <!--                                    ? 'radio_button_checked'-->
                        <!--                                    : 'radio_button_unchecked'-->
                        <!--                            }}-->
                        <!--                        </span>-->
                    </div>
                </div>
            </div>
            <div class="phone-list" *ngIf="phoneValidation && !emailValidation">
                <div mat-ripple matRippleColor="#CCCCCC25"
                     class="phone-item"
                     [class.card-theme-color]="phone === selectedPhone && !expressMode"
                     [class.card-theme-border-color]="phone === selectedPhone && !expressMode"
                     [class.glance-card-theme-color]="phone === selectedPhone && expressMode"
                     (click)="setSelectedPhone(phone)"
                     *ngFor="let phone of phones">
                    <div class="d-flex flex-row align-items-center">
                        <span class="material-symbols-rounded primary-icon me-3">
                            {{ phone === selectedPhone ? 'radio_button_checked' : 'radio_button_unchecked' }}
                        </span>
                        <div class="lateral-data-img me-3">
                            <span class="material-symbols-rounded square-icon">phone</span>
                        </div>
                        <div class="lateral-data-textarea">
                            <p class="medium-text spaced-label m-0" [style.word-break]="'break-all'">
                                +{{ phone.pais }}{{ phone.telefono }}
                            </p>
<!--                            <p class="small-label" *ngIf="phone === selectedPhone">Enviaremos un código de-->
<!--                                verificación</p>-->
                        </div>
                    </div>
                    <div class="lateral-data-options">

                    </div>
                </div>
            </div>
        </div>
        <div class="h-100 m-auto" [hidden]="!emailValidation || emails.length > 0">
            <div class="no-data-layout">
<!--                <img src="../../../assets/img/empty_cart_caliwallet.svg"-->
<!--                     class="mx-auto p-2"-->
<!--                     width="96"-->
<!--                     height="96"-->
<!--                     alt="Empty cart">-->
                <div class="py-3">
                    <p class="medium-label app-module-title mx-0 mt-2">
                        No hay correos electronicos registrados
                    </p>
                    <p class="small-label m-0">
                        Por favor agrega un correo electrónico al que
                        tengas acceso para validarlo.
                    </p>
                </div>
            </div>
        </div>
        <div class="h-100 m-auto" [hidden]="!phoneValidation || phones.length > 0">
            <div class="no-data-layout">
<!--                <img src="../../../assets/img/empty_cart_caliwallet.svg"-->
<!--                     class="mx-auto p-2"-->
<!--                     width="96"-->
<!--                     height="96"-->
<!--                     alt="Empty cart">-->
                <div class="py-3">
                    <p class="medium-label app-module-title mx-0 mt-2">
                        No hay numeros de teléfono registrados
                    </p>
                    <p class="small-label m-0">
                        Por favor agrega un numero de teléfono al que
                        tengas acceso para validarlo.
                    </p>
                </div>
            </div>
        </div>
        <div class="validate-dialog-height" [hidden]="!userSelectedAccount">
            <app-sms-verification #codeVerification
                                  (userHasVerifiedCode)="onUserVerifiedCode($event)">
            </app-sms-verification>
        </div>
    </div>
    <div class="validate-bottom pb-4">
        <div class="multiple-separation-bottom-actions">
            <button mat-flat-button
                    [hidden]="expressMode || !navigationActions"
                    (click)="onCartStep()"
                    class="link-action-btn w-100">
                <span class="material-symbols-rounded">arrow_back</span>
                Carrito
            </button>
            <button mat-flat-button
                    [hidden]="userSelectedAccount || !emailValidation"
                    (click)="openAddingDialog('email', 'MCEmail')"
                    class="link-action-btn w-100">
                <span class="material-symbols-rounded">email</span>
                Agregar correo electronico
            </button>
            <button mat-flat-button
                    [hidden]="userSelectedAccount || !phoneValidation"
                    (click)="openAddingDialog('telefono', 'MCPhone')"
                    class="link-action-btn w-100">
                <span class="material-symbols-rounded">phone</span>
                Agregar teléfono
            </button>
            <button mat-flat-button
                    [hidden]="userSelectedAccount"
                    [disabled]="!userPreselectedAccount"
                    class="role-action-btn w-100"
                    (click)="sendValidationCode()">
                Enviar código
            </button>
        </div>
    </div>
</div>
